import React from 'react';
import { KostnadsKalkyleProvider } from './context/KostnadsKalkyleProvider';
import type { KostnadsKalkyleProps } from './context/KostnadsKalkyleProps';
import type { WithSubComponents } from '@forvalter/utils/TypeScriptUtils';
import { KostnadsKalkyleTitle } from './KostnadsKalkyleTitle';
import { KostnadsKalkyleModal } from './Modal/KostnadsKalkyleModal';

type KostnadsKalkyleSubComponents = {
    Provider: typeof KostnadsKalkyleProvider;
    Title: typeof KostnadsKalkyleTitle;
    Modal: typeof KostnadsKalkyleModal;
};

export const KostnadsKalkyle: WithSubComponents<
    React.FC<KostnadsKalkyleProps>,
    KostnadsKalkyleSubComponents
> = ({
    field,
    prosessInstansId,
    prosjektId,
    isReadOnly,
    isRequired,
    prosjektNavn,
}) => {
    return (
        <KostnadsKalkyle.Provider
            field={field}
            prosjektId={prosjektId}
            prosessInstansId={prosessInstansId}
            isReadOnly={isReadOnly}
            isRequired={isRequired}
            prosjektNavn={prosjektNavn}
        >
            <KostnadsKalkyle.Title />
            <KostnadsKalkyle.Modal />
            <KostnadsKalkyle.Modal.Trigger />
        </KostnadsKalkyle.Provider>
    );
};

KostnadsKalkyle.Provider = KostnadsKalkyleProvider;
KostnadsKalkyle.Title = KostnadsKalkyleTitle;
KostnadsKalkyle.Modal = KostnadsKalkyleModal;
